module.exports = __webpack_public_path__ + "static/img/letseewhite.b3d6b057.svg";